export const GET_LOCKED_ACTIVATION_DATA = "GET_LOCKED_ACTIVATION_DATA";
export const GET_LOCKED_ACTIVATION_DATA_SUCCESSFULL = "GET_LOCKED_ACTIVATION_DATA_SUCCESSFULL";
export const GET_LOCKED_ACTIVATION_DATA_FAILED = "GET_LOCKED_ACTIVATION_DATA_FAILED";
export const UNLOCK_ACTIVATION_BY_OTHER = "UNLOCK_ACTIVATION_BY_OTHER";
export const UNLOCK_ACTIVATION_BY_OTHER_SUCCESS = "UNLOCK_ACTIVATION_BY_OTHER_SUCCESS";
export const UNLOCK_ACTIVATION_BY_OTHER_FAILED = "UNLOCK_ACTIVATION_BY_OTHER_FAILED";